"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstallmentTerm;
(function (InstallmentTerm) {
    InstallmentTerm["ONE_TIME"] = "One-time";
    InstallmentTerm["MONTHLY"] = "Monthly";
    InstallmentTerm["QUARTERLY"] = "Quarterly";
})(InstallmentTerm = exports.InstallmentTerm || (exports.InstallmentTerm = {}));
var Status;
(function (Status) {
    Status["OPEN"] = "Open";
    Status["CONFIRMED"] = "Confirmed";
    Status["COMPLETE"] = "Complete";
    Status["ACTIVATED"] = "Activated";
    Status["PARTIALLY_COMPLETE"] = "Partially Complete";
    Status["CANCELLED"] = "Cancelled";
    Status["FAILED"] = "Failed";
    // DRAFT = 'DRAFT(inactive)', // TODO: Not yet in Order entity's STATUS picklist
})(Status = exports.Status || (exports.Status = {}));
var PaymentTerm;
(function (PaymentTerm) {
    PaymentTerm["DUE_UPON_RECEIPT"] = "Due Upon Receipt";
    PaymentTerm["NET_30"] = "Net 30";
})(PaymentTerm = exports.PaymentTerm || (exports.PaymentTerm = {}));
var PricebookExternalId;
(function (PricebookExternalId) {
    PricebookExternalId["STANDARD_PB"] = "standardPB";
})(PricebookExternalId = exports.PricebookExternalId || (exports.PricebookExternalId = {}));
var RecordTypeName;
(function (RecordTypeName) {
    RecordTypeName["DRAFT_ORDER"] = "Draft Order";
    RecordTypeName["INDIVIDUAL_MEMBERSHIP"] = "Individual Membership";
    RecordTypeName["FIRM_MEMBERSHIP"] = "Firm Membership";
    RecordTypeName["SPECIAL_CONSIDERATION"] = "Special Consideration";
    // Attestation
    RecordTypeName["GENERIC_ATTESTATION"] = "Generic Attestation";
    RecordTypeName["CREDENTIAL_ATTESTATION"] = "Credential Attestation";
    RecordTypeName["FIRM_MEMBERSHIP_ATTESTATION"] = "Firm Membership Attestation";
    RecordTypeName["INDIVIDUAL_MEMBERSHIP_ATTESTATION"] = "Individual Membership Attestation";
    RecordTypeName["ECKOH_RENEWAL_ATTESTATION"] = "Eckoh Renewal Attestation";
    RecordTypeName["AML_APPLICATION"] = "AML Application";
    RecordTypeName["APPRENTICE_APPLICATION"] = "Apprentice Attestation";
    RecordTypeName["CASE_ATTESTATION"] = "Case Attestation";
    RecordTypeName["DONATION_ATTESTATION"] = "Donation Attestation";
    RecordTypeName["MIP_PRACTICE_REQ_DETAILS"] = "MIP Practice Requirements Details";
    RecordTypeName["PER_MODULE_ATTESTATION"] = "PER Module Attestation";
    RecordTypeName["PERSON_LEVEL_EXEMPTION"] = "Person Level Exemption";
    RecordTypeName["VALIDATOR_ATTESTATION"] = "Validator Attestation";
    // Application Part
    RecordTypeName["INDIVIDUAL_MEMBERSHIP_AFFILIATE"] = "Individual Membership - Affiliate";
    RecordTypeName["INDIVIDUAL_MEMBERSHIP_CANDIDATE"] = "Individual Membership - Candidate";
    RecordTypeName["INDIVIDUAL_MEMBERSHIP_INTERNATIONAL_ASSOCIATE"] = "Individual Membership - International Associate";
    RecordTypeName["INDIVIDUAL_MEMBERSHIP_REGULAR"] = "Individual Membership - Regular";
    RecordTypeName["INDIVIDUAL_MEMBERSHIP_RETIRED"] = "Individual Membership - Retired";
    RecordTypeName["APPRENTICE_ASSESSMENT"] = "Apprentice Assessment";
})(RecordTypeName = exports.RecordTypeName || (exports.RecordTypeName = {}));
var Provisioning;
(function (Provisioning) {
    Provisioning["EXTERNAL_PROVISION"] = "EXTERNAL_PROVISION";
    Provisioning["RAVE"] = "RAVE";
    Provisioning["RAVE_PHYSICAL"] = "RAVE_PHYSICAL";
    Provisioning["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(Provisioning = exports.Provisioning || (exports.Provisioning = {}));
var CaseAssessmentOrigin;
(function (CaseAssessmentOrigin) {
    CaseAssessmentOrigin["WEB"] = "Web";
    CaseAssessmentOrigin["EMAIL"] = "Email";
    CaseAssessmentOrigin["PHONE"] = "Phone";
    CaseAssessmentOrigin["ASSESSMENT"] = "Assessment";
})(CaseAssessmentOrigin = exports.CaseAssessmentOrigin || (exports.CaseAssessmentOrigin = {}));
var CaseAssessmentStatus;
(function (CaseAssessmentStatus) {
    CaseAssessmentStatus["VOID"] = "Void";
    CaseAssessmentStatus["OPEN"] = "Open";
    CaseAssessmentStatus["DRAFTED"] = "Draft";
    CaseAssessmentStatus["CLOSED"] = "Closed";
    CaseAssessmentStatus["SCREENING"] = "Screening";
    CaseAssessmentStatus["WITHDRAWN"] = "Withdrawn";
    CaseAssessmentStatus["IN_ARBITRATION"] = "In Arbitration";
    CaseAssessmentStatus["PRACTICE_SCRIPT"] = "Practice Script";
    CaseAssessmentStatus["PENDING_ASSESSMENT"] = "Pending Assessment";
    CaseAssessmentStatus["PENDING_VALIDATION"] = "Pending Validation";
    CaseAssessmentStatus["PENDING_SUBMISSION"] = "Pending Submission";
    CaseAssessmentStatus["REQUESTED_FURTHER_INFORMATION"] = "Requested further information";
})(CaseAssessmentStatus = exports.CaseAssessmentStatus || (exports.CaseAssessmentStatus = {}));
var AccountContactRole;
(function (AccountContactRole) {
    AccountContactRole["CLIENT_ADMIN"] = "Client Admin";
    AccountContactRole["FIRM_BILLING_CLIENT_ADMIN"] = "Billing Admin";
    AccountContactRole["FIRM_BILLING_ADMIN"] = "Firm Billing Admin";
    AccountContactRole["CENTERS_ADMIN"] = "Centers Admin";
    AccountContactRole["PARTNER_ADMIN"] = "Partner Admin";
    AccountContactRole["PARTNER"] = "Partner";
    AccountContactRole["ADMIN"] = "Admin";
    AccountContactRole["OWNER"] = "Owner";
    AccountContactRole["ANY"] = "Any";
})(AccountContactRole = exports.AccountContactRole || (exports.AccountContactRole = {}));
var thirdPartyFieldsType;
(function (thirdPartyFieldsType) {
    thirdPartyFieldsType["FIRSTNAME"] = "First Name";
    thirdPartyFieldsType["LASTNAME"] = "Last Name";
    thirdPartyFieldsType["PRIMARY_EMAIL_ADD"] = "Primary Email Address";
    thirdPartyFieldsType["PRIMARY_EMAIL_TYPE"] = "Primary Email Address Type";
    thirdPartyFieldsType["SECONDARY_EMAIL_ADD"] = "Secondary Email Address";
    thirdPartyFieldsType["SECONDARY_EMAIL_TYPE"] = "Secondary Email Address Type";
    thirdPartyFieldsType["PRIMARY_PHONE"] = "Primary Phone";
    thirdPartyFieldsType["PRIMARY_PHONE_TYPE"] = "Primary Phone Type";
    thirdPartyFieldsType["SECONDARY_PHONE"] = "Secondary Phone";
    thirdPartyFieldsType["SECONDARY_PHONE_TYPE"] = "Secondary Phone Type";
    thirdPartyFieldsType["PRIMARY_ADDRESS"] = "Primary Address";
    thirdPartyFieldsType["ALTERNATIVE_ADDRESS"] = "Alternate Address";
    thirdPartyFieldsType["GENDER"] = "Gender";
    thirdPartyFieldsType["BIRTH_DATE"] = "BirthDate";
    thirdPartyFieldsType["CPA_LICENSE"] = "CPA License";
    thirdPartyFieldsType["ORG_BUSINESS_NAME"] = "Organization Name";
    thirdPartyFieldsType["ORG_BUSINESS_CITY"] = "Organization City";
    thirdPartyFieldsType["AICPA_MEMBERSHIP"] = "AICPA Membership";
})(thirdPartyFieldsType = exports.thirdPartyFieldsType || (exports.thirdPartyFieldsType = {}));
var EmailType;
(function (EmailType) {
    EmailType["PERSONAL"] = "Personal";
    EmailType["BUSINESS"] = "Business";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
var PhoneType;
(function (PhoneType) {
    PhoneType["MOBILE"] = "Mobile";
    PhoneType["HOME"] = "Home";
    PhoneType["WORK"] = "Work";
})(PhoneType = exports.PhoneType || (exports.PhoneType = {}));
var HomeAddressType;
(function (HomeAddressType) {
    HomeAddressType["HOME"] = "Home";
    HomeAddressType["OFFICE_MAILING"] = "Office Mailing";
    HomeAddressType["OFFICE_STREET"] = "Office Street";
    HomeAddressType["SCHOOL"] = "School";
})(HomeAddressType = exports.HomeAddressType || (exports.HomeAddressType = {}));
var EPA2Status;
(function (EPA2Status) {
    EPA2Status["SUBMITTED"] = "Submitted";
    EPA2Status["ACCEPTED"] = "Accepted";
    EPA2Status["REJECTED"] = "Rejected";
})(EPA2Status = exports.EPA2Status || (exports.EPA2Status = {}));
var AccountPersonAccountStatuses;
(function (AccountPersonAccountStatuses) {
    AccountPersonAccountStatuses["ACTIVE"] = "Active";
    AccountPersonAccountStatuses["INACTIVE"] = "Inactive";
    AccountPersonAccountStatuses["ANY"] = "Any";
})(AccountPersonAccountStatuses = exports.AccountPersonAccountStatuses || (exports.AccountPersonAccountStatuses = {}));
var AdminType;
(function (AdminType) {
    AdminType["FIRM_BILLING_ADMIN"] = "Firm Billing Admin";
    AdminType["CLIENT_ADMIN"] = "Client Admin";
    AdminType["CENTERS_ADMIN"] = "Centers Admin";
})(AdminType = exports.AdminType || (exports.AdminType = {}));
var RetiredMembershipReason;
(function (RetiredMembershipReason) {
    RetiredMembershipReason["NOT_WORKING"] = "I am not working.";
    RetiredMembershipReason["WORKING_LESS_20_HOURS"] = "I am working less than 20 hours per week.";
})(RetiredMembershipReason = exports.RetiredMembershipReason || (exports.RetiredMembershipReason = {}));
var PassCPAExamOptions;
(function (PassCPAExamOptions) {
    PassCPAExamOptions["PASSED"] = "Yes, I did";
    PassCPAExamOptions["NOT_PASSED"] = "No, I didn\u2019t";
})(PassCPAExamOptions = exports.PassCPAExamOptions || (exports.PassCPAExamOptions = {}));
var CandidateEmploymentOptions;
(function (CandidateEmploymentOptions) {
    CandidateEmploymentOptions["A_STUDENT"] = "A University Student";
    CandidateEmploymentOptions["CURRENTLY_EMPLOYED"] = "Currently Employed";
    CandidateEmploymentOptions["BOTH"] = "Both";
})(CandidateEmploymentOptions = exports.CandidateEmploymentOptions || (exports.CandidateEmploymentOptions = {}));
var InternationalAssocEmployment;
(function (InternationalAssocEmployment) {
    InternationalAssocEmployment["EMPLOYED"] = "I am employed part time or full time";
    InternationalAssocEmployment["OUT_OF_WORKPLACE"] = "I am temporarily out of the workforce";
})(InternationalAssocEmployment = exports.InternationalAssocEmployment || (exports.InternationalAssocEmployment = {}));
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["ACTIVE"] = "Active";
    MembershipStatus["LAPSED"] = "Lapsed";
    MembershipStatus["GRACE"] = "Grace Period";
    MembershipStatus["SUSPENDED"] = "Suspended";
    MembershipStatus["RESIGNED"] = "Resigned";
    MembershipStatus["TERMINATED"] = "Terminated";
    MembershipStatus["GRACE_V2"] = "Grace";
})(MembershipStatus = exports.MembershipStatus || (exports.MembershipStatus = {}));
var FirmMembershipTypes;
(function (FirmMembershipTypes) {
    FirmMembershipTypes["EBPAQC"] = "EBPAQC";
    FirmMembershipTypes["GAQC"] = "GAQC";
    FirmMembershipTypes["CPEA"] = "CPEA";
    FirmMembershipTypes["PCPS"] = "PCPS";
    FirmMembershipTypes["CAQ_REGULAR"] = "CAQ - Regular";
    FirmMembershipTypes["CAQ_ASSOCIATE"] = "CAQ - Associate";
})(FirmMembershipTypes = exports.FirmMembershipTypes || (exports.FirmMembershipTypes = {}));
var PracticalExperienceRecordStatus;
(function (PracticalExperienceRecordStatus) {
    PracticalExperienceRecordStatus["SUBMITTED"] = "Submitted";
    PracticalExperienceRecordStatus["DRAFTED"] = "Drafted";
    PracticalExperienceRecordStatus["SIGNED_OFF"] = "Signed Off";
    PracticalExperienceRecordStatus["ACTION_REQUIRED"] = "Action Required";
    PracticalExperienceRecordStatus["APPROVED"] = "Approved";
    PracticalExperienceRecordStatus["EMPTY"] = "Empty";
})(PracticalExperienceRecordStatus = exports.PracticalExperienceRecordStatus || (exports.PracticalExperienceRecordStatus = {}));
var PERFeedbackStatus;
(function (PERFeedbackStatus) {
    PERFeedbackStatus["NOT_REQUESTED"] = "Not requested";
    PERFeedbackStatus["DRAFT"] = "Draft";
    PERFeedbackStatus["WITHDRAWN"] = "Withdrawn";
    PERFeedbackStatus["ACTION_REQUIRED"] = "Action Required";
    PERFeedbackStatus["APPROVED"] = "Approved";
    PERFeedbackStatus["REJECTED"] = "Rejected";
    PERFeedbackStatus["AUDIT_APPROVE"] = "Approve";
    PERFeedbackStatus["AUDITED"] = "Audited";
    PERFeedbackStatus["AUDIT_PENDING"] = "Pending";
})(PERFeedbackStatus = exports.PERFeedbackStatus || (exports.PERFeedbackStatus = {}));
var PerPortfolioStatus;
(function (PerPortfolioStatus) {
    PerPortfolioStatus["COMPLETED"] = "Completed";
    PerPortfolioStatus["SUBMITTED"] = "Submitted";
    PerPortfolioStatus["DRAFT"] = "Draft";
    PerPortfolioStatus["IN_AUDIT"] = "In Audit";
})(PerPortfolioStatus = exports.PerPortfolioStatus || (exports.PerPortfolioStatus = {}));
var ExemptionRecordType;
(function (ExemptionRecordType) {
    ExemptionRecordType["PROFESSIONAL_QUALIFICATION"] = "Professional_Qualifications_Exemption_Reference";
    ExemptionRecordType["EDUCATIONAL_QUALIFICATION"] = "Educational_Qualifications_Exemption_Reference";
    ExemptionRecordType["WORK_EXPERIENCE"] = "Work_Experience_Exemption_Reference";
})(ExemptionRecordType = exports.ExemptionRecordType || (exports.ExemptionRecordType = {}));
var ExamRegistrationMethod;
(function (ExamRegistrationMethod) {
    ExamRegistrationMethod["VUE_WEBSITE"] = "Vue Website";
    ExamRegistrationMethod["VUE_REGISTRATION_CENTER"] = "Vue Registration Center";
})(ExamRegistrationMethod = exports.ExamRegistrationMethod || (exports.ExamRegistrationMethod = {}));
var ExamBookingStatus;
(function (ExamBookingStatus) {
    ExamBookingStatus["Active"] = "Active";
    ExamBookingStatus["Cancelled"] = "Cancelled";
    ExamBookingStatus["Delivered"] = "Delivered";
    ExamBookingStatus["NoShow"] = "No Show";
    ExamBookingStatus["ndaRefused"] = "NDA Refused";
})(ExamBookingStatus = exports.ExamBookingStatus || (exports.ExamBookingStatus = {}));
var ExamRecordType;
(function (ExamRecordType) {
    ExamRecordType["FLPCompetencyGroup"] = "FLP_Competency_Group";
    ExamRecordType["EPA2"] = "EPA2";
    ExamRecordType["PearsonVue"] = "Pearson_Vue";
})(ExamRecordType = exports.ExamRecordType || (exports.ExamRecordType = {}));
var DocumentUploadStatus;
(function (DocumentUploadStatus) {
    DocumentUploadStatus["Draft"] = "Draft";
    DocumentUploadStatus["Submitted"] = "Submitted";
})(DocumentUploadStatus = exports.DocumentUploadStatus || (exports.DocumentUploadStatus = {}));
var DocumentLimit;
(function (DocumentLimit) {
    DocumentLimit[DocumentLimit["Limit_4mb"] = 4000000] = "Limit_4mb";
})(DocumentLimit = exports.DocumentLimit || (exports.DocumentLimit = {}));
var CaseRecordType;
(function (CaseRecordType) {
    CaseRecordType["ApprenticeAssessment"] = "Apprentice Assessment";
    CaseRecordType["AuditCase"] = "Audit Case";
    CaseRecordType["DataRequest"] = "Data Request";
    CaseRecordType["GeneralCase"] = "General Case";
    CaseRecordType["SpecialAccommodation"] = "Special Accommodation";
})(CaseRecordType = exports.CaseRecordType || (exports.CaseRecordType = {}));
var DETAIL_TYPE;
(function (DETAIL_TYPE) {
    DETAIL_TYPE["ORGANISATION_ACCOUNT"] = "Organisation_Account_PE__e";
    DETAIL_TYPE["PERSON_ACCOUNT"] = "Person_Account_Platform_Event__e";
    DETAIL_TYPE["PERSON_ADDRESS"] = "Contact_Point_Address_Platform_Event__e";
    DETAIL_TYPE["PERSON_CERTIFICATE"] = "Person_Certificate_PE__e";
    DETAIL_TYPE["PERSON_EMAIL"] = "Contact_Point_Email_Platform_Event__e";
    DETAIL_TYPE["PERSON_PHONE"] = "Contact_Point_Phone_Platform_Event__e";
    DETAIL_TYPE["APPLICATION"] = "Application_PE__e";
    DETAIL_TYPE["FIRM_BILLING"] = "Firm_Billing_Type_PE__e";
    DETAIL_TYPE["ACCOUNT_PERSON_ACCOUNT"] = "Account_Person_Account_PE__e";
    DETAIL_TYPE["PERSON_ACCOUNT_ETHICS"] = "Person_Account_Ethics_Status_PE__e";
    DETAIL_TYPE["MEMBERSHIP"] = "Membership_PE__e";
    DETAIL_TYPE["MEMBERSHIP_TERM"] = "Membership_Term_PE__e";
    DETAIL_TYPE["EXAM_AUTHORISATION"] = "Exam_Authorisation_PE__e";
    DETAIL_TYPE["PERSON_SPECIAL_ACCOMMODATION"] = "Person_Special_Accommodation_PE__e";
    DETAIL_TYPE["PERSON_QUALIFICATION_LEVEL"] = "Person_Qualification_Level_PE__e";
    DETAIL_TYPE["EXAM_CREDIT"] = "Exam_Credit_Platform_Event__e";
    DETAIL_TYPE["PERSON_EXAM_EXEMPTION"] = "Person_Exam_Exemption_PE__e";
    DETAIL_TYPE["UPCOMING_EXAM_BOOKING"] = "Upcoming_Exam_Booking_PE__e";
    DETAIL_TYPE["EXAM_RESULT"] = "CIMA_Exam_Result_PE__e";
    DETAIL_TYPE["PRACTICAL_EXPERIENCE_REQUIREMENT_AUDIT"] = "PER_Audit_and_External_Validator_PE__e";
    DETAIL_TYPE["PRACTICAL_EXPERIENCE_REQUIREMENT_PORTFOLIO"] = "PER_Portfolio_PE__e";
    DETAIL_TYPE["ASSESSMENT_PLATFORM"] = "Assessment_Platform_Event__e";
    DETAIL_TYPE["STATE_SOCIETY_MEMBER"] = "State_Society_Member_PE__c";
    DETAIL_TYPE["PERSON_ACCOUNT_CROSS_ENTITY"] = "Person_Account_Cross_Entity_PE__e";
})(DETAIL_TYPE = exports.DETAIL_TYPE || (exports.DETAIL_TYPE = {}));
/**
 * Operation_Type_PE__c
 */
var OPERATION_TYPE;
(function (OPERATION_TYPE) {
    OPERATION_TYPE["CREATED"] = "CREATED";
    OPERATION_TYPE["UPDATED"] = "UPDATED";
    OPERATION_TYPE["DELETED"] = "DELETED";
    OPERATION_TYPE["MERGED_FOR_PA"] = "ACCOUNT MERGED FOR PA";
    OPERATION_TYPE["MERGED_FOR_ORG"] = "ACCOUNT MERGED FOR ORG";
    OPERATION_TYPE["FIRM_UPDATED_GENERAL"] = "UPDATED GENERAL ORGANISATION PLATFORM EVENT";
    OPERATION_TYPE["FIRM_UPDATED_ADDRESS"] = "UPDATED ORGANISATION ADDRESS";
    OPERATION_TYPE["FIRM_UPDATED_PHONE"] = "UPDATED ORGANISATION PRIMARY PHONE";
    OPERATION_TYPE["FIRM_UPDATED_EMAIL"] = "UPDATED ORGANISATION EMAIL";
    // Exam Auth operation Type
    OPERATION_TYPE["END_DATE_MET"] = "END DATE MET";
    OPERATION_TYPE["EXAM_CANCELLATION"] = "EXAM CANCELLATION";
    OPERATION_TYPE["EXAM_AUTH_EXTENDED"] = "EXAM AUTH IS 6 MONTHS BEFORE END DATE";
    OPERATION_TYPE["UPDATED_STATE_SOCIETY_MEMBER"] = "UPDATED STATE SOCIETY MEMBERS";
    OPERATION_TYPE["UPDATED_ETHICS_STATUS"] = "UPDATED ETHICS STATUS";
})(OPERATION_TYPE = exports.OPERATION_TYPE || (exports.OPERATION_TYPE = {}));
var MODEL_TYPE;
(function (MODEL_TYPE) {
    MODEL_TYPE["INDIVIDUAL"] = "Individual";
    MODEL_TYPE["INDIVIDUAL_ADDRESS"] = "IndividualAddress";
    MODEL_TYPE["INDIVIDUAL_EMAIL"] = "IndividualEmail";
    MODEL_TYPE["INDIVIDUAL_PHONE"] = "IndividualPhone";
    MODEL_TYPE["INDIVIDUAL_MEMBERSHIP"] = "IndividualMembership";
    MODEL_TYPE["INDIVIDUAL_CERTIFICATE"] = "IndividualCertificate";
    MODEL_TYPE["IND_FIRM_RELATIONSHIP"] = "IndOrgRelationship";
    MODEL_TYPE["FIRM"] = "Firm";
    MODEL_TYPE["FIRM_ADDRESS"] = "FirmAddress";
    MODEL_TYPE["FIRM_EMAIL"] = "FirmEmail";
    MODEL_TYPE["FIRM_PHONE"] = "FirmPhone";
    MODEL_TYPE["FIRM_MEMBERSHIP"] = "FirmMembership";
    MODEL_TYPE["CUSTOM_INDIVIDUAL"] = "CustomIndividual";
    MODEL_TYPE["CUSTOM_FIRM"] = "CustomOrganization";
})(MODEL_TYPE = exports.MODEL_TYPE || (exports.MODEL_TYPE = {}));
var ReviewerDecision;
(function (ReviewerDecision) {
    ReviewerDecision["WITHDRAW"] = "WITHDRAW";
    ReviewerDecision["AUDIT_APPROVED"] = "AUDIT_APPROVED";
    ReviewerDecision["AUDIT_REJECTED"] = "AUDIT_REJECTED";
})(ReviewerDecision = exports.ReviewerDecision || (exports.ReviewerDecision = {}));
var DATE_FORMAT;
(function (DATE_FORMAT) {
    DATE_FORMAT["LONG"] = "MM/DD/YYYY HH:mm:ss";
    DATE_FORMAT["SHORT"] = "MM/DD/YYYY";
})(DATE_FORMAT = exports.DATE_FORMAT || (exports.DATE_FORMAT = {}));
var APA_RELATIONSHIP_TYPE;
(function (APA_RELATIONSHIP_TYPE) {
    APA_RELATIONSHIP_TYPE["FIRM_BILLING"] = "Firm Billing";
    APA_RELATIONSHIP_TYPE["ADMIN"] = "Admin";
    APA_RELATIONSHIP_TYPE["EMPLOYEE"] = "Employee";
    APA_RELATIONSHIP_TYPE["STUDENT"] = "Student";
    APA_RELATIONSHIP_TYPE["IND_FIRM_RELATIONSHIP"] = "Ind_Org";
})(APA_RELATIONSHIP_TYPE = exports.APA_RELATIONSHIP_TYPE || (exports.APA_RELATIONSHIP_TYPE = {}));
var ORG_ADDRESS_TYPE;
(function (ORG_ADDRESS_TYPE) {
    ORG_ADDRESS_TYPE["PHYSICAL_ADDRESS"] = "Org Office Physical Address";
    ORG_ADDRESS_TYPE["MAILING_ADDRESS"] = "Org Office Mailing Address";
})(ORG_ADDRESS_TYPE = exports.ORG_ADDRESS_TYPE || (exports.ORG_ADDRESS_TYPE = {}));
exports.PUBLIC_ACCOUNTING = 'Public Accounting';
var LegalEntity;
(function (LegalEntity) {
    LegalEntity["ASSOCIATION"] = "Association";
    LegalEntity["CIMA"] = "CIMA";
})(LegalEntity = exports.LegalEntity || (exports.LegalEntity = {}));
var EmployerInformationAction;
(function (EmployerInformationAction) {
    EmployerInformationAction["REPLACE"] = "replace";
    EmployerInformationAction["EDIT"] = "edit";
})(EmployerInformationAction = exports.EmployerInformationAction || (exports.EmployerInformationAction = {}));
var CimaStatus;
(function (CimaStatus) {
    CimaStatus["ENROLLED"] = "Enrolled";
    CimaStatus["PENDING_CONFIRMATION"] = "Pending Confirmation";
    CimaStatus["REJECTED"] = "Rejected";
    CimaStatus["SWITCHED"] = "Switch to another TP or Pathways";
    CimaStatus["DEPROVISIONED"] = "Deprovisioned";
    CimaStatus["AVAILABLE"] = "Available";
    CimaStatus["WITHDRAWN"] = "Withdrawn";
})(CimaStatus = exports.CimaStatus || (exports.CimaStatus = {}));
var TuitionProviderAdminAction;
(function (TuitionProviderAdminAction) {
    TuitionProviderAdminAction["CONFIRM"] = "confirm";
    TuitionProviderAdminAction["REMOVAL"] = "removed";
    TuitionProviderAdminAction["REJECTED_SIGNUP"] = "signup-rejected";
    TuitionProviderAdminAction["REJECTED_SWITCH"] = "switch-rejected";
})(TuitionProviderAdminAction = exports.TuitionProviderAdminAction || (exports.TuitionProviderAdminAction = {}));
var ApprenticeGatewayStatus;
(function (ApprenticeGatewayStatus) {
    ApprenticeGatewayStatus["PASSED"] = "Passed";
    ApprenticeGatewayStatus["PENDING"] = "Pending";
})(ApprenticeGatewayStatus = exports.ApprenticeGatewayStatus || (exports.ApprenticeGatewayStatus = {}));
var LicenseNumberEnum;
(function (LicenseNumberEnum) {
    LicenseNumberEnum["DEFAULT"] = "000";
})(LicenseNumberEnum = exports.LicenseNumberEnum || (exports.LicenseNumberEnum = {}));
var DashboardTypeEnum;
(function (DashboardTypeEnum) {
    DashboardTypeEnum["EPA"] = "EPA";
    DashboardTypeEnum["PER"] = "PER";
})(DashboardTypeEnum = exports.DashboardTypeEnum || (exports.DashboardTypeEnum = {}));
var EPAStatus;
(function (EPAStatus) {
    EPAStatus["SCREENING"] = "Screening";
    EPAStatus["PENDING_VALIDATION"] = "Pending Validation";
    EPAStatus["WITHDRAWN"] = "Withdrawn";
    EPAStatus["REQUESTED_FURTHER_INFORMATION"] = "Requested further information";
})(EPAStatus = exports.EPAStatus || (exports.EPAStatus = {}));
var TuitionProviderType;
(function (TuitionProviderType) {
    TuitionProviderType["TUITION_PROVIDER"] = "Tuition Provider";
    TuitionProviderType["TUITION_PROVIDER_APPRENTICES"] = "Tuition Provider apprentices";
    TuitionProviderType["NONE"] = "None";
})(TuitionProviderType = exports.TuitionProviderType || (exports.TuitionProviderType = {}));
var PERModuleType;
(function (PERModuleType) {
    PERModuleType["CORE"] = "Core";
    PERModuleType["SKILLS"] = "Skills";
    PERModuleType["EMPLOYMENT"] = "Employment";
})(PERModuleType = exports.PERModuleType || (exports.PERModuleType = {}));
var PersonCertificateStatus;
(function (PersonCertificateStatus) {
    PersonCertificateStatus["NONE"] = "None";
    PersonCertificateStatus["SCREENING"] = "Screening";
    PersonCertificateStatus["PENDING_INFO"] = "Pending for Information";
    PersonCertificateStatus["READY_FOR_APPLY"] = "Ready for apply";
    PersonCertificateStatus["PROGRESSING"] = "Progressing";
    PersonCertificateStatus["REISSUE_PROGRESS"] = "Reissue in Progress";
    PersonCertificateStatus["SUBMITTED_EXT"] = "Submitted to external body";
    PersonCertificateStatus["FAILED"] = "Failed";
})(PersonCertificateStatus = exports.PersonCertificateStatus || (exports.PersonCertificateStatus = {}));
var FirmBilling;
(function (FirmBilling) {
    FirmBilling["FBE_RENEWING"] = "FBE Renewing";
    FirmBilling["FBE_NON_RENEWING"] = "FBE Non-Renewing";
    FirmBilling["FLP_CIMA_RENEWING"] = "FLP CIMA Renewing";
    FirmBilling["FLP_CIMA_NON_RENEWING"] = "FLP CIMA Non-Renewing";
    FirmBilling["FLP_AICPA_RENEWING"] = "FLP AICPA Renewing";
    FirmBilling["FLP_AICPA_NON_RENEWING"] = "FLP AICPA Non-Renewing";
})(FirmBilling = exports.FirmBilling || (exports.FirmBilling = {}));
var EmailRecipientTypes;
(function (EmailRecipientTypes) {
    EmailRecipientTypes["TP"] = "TuitionProvider";
    EmailRecipientTypes["EMPLOYER"] = "Employer";
    EmailRecipientTypes["APPRENTICE"] = "Apprentice";
    EmailRecipientTypes["EPAC"] = "EPAC";
})(EmailRecipientTypes = exports.EmailRecipientTypes || (exports.EmailRecipientTypes = {}));
var DataSharingConsentEnum;
(function (DataSharingConsentEnum) {
    DataSharingConsentEnum["READ_ONLY"] = "Read only";
    DataSharingConsentEnum["READ_AND_WRITE"] = "Read and write";
    DataSharingConsentEnum["READ_WRITE_AND_DELETE"] = "Read, write and delete";
})(DataSharingConsentEnum = exports.DataSharingConsentEnum || (exports.DataSharingConsentEnum = {}));
//# sourceMappingURL=index.js.map